export class DetailsProduct {
    constructor(id, idp, description, imgUrls, relatedProducts) {
        this.id = id;
        this.idp = idp;
        this.description = description;
        this.imgUrls = imgUrls;
        this.relatedProducts = relatedProducts;
    }
}
